// import { useFormik } from 'formik'
import React, { FC, useEffect, useState } from 'react'
import { Button, Modal, Upload, Row, Col, Typography, Radio, RadioChangeEvent, Space } from 'antd'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import { InboxOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
import { Banks, getBankColor, getBankName } from '../../helpers/bank'
import { toast } from 'react-toastify'
import { requestUser } from '../../store/user/user.actions'
import api from '../../helpers/api'
import { APIResponse } from '../../@types/api'
import { requestDepositTo } from '../../store/deposit/deposit.actions'
interface UploadSlipProps {
	isOpen: boolean
	onClose: () => void
}
const { Text } = Typography

const UploadSlip: FC<UploadSlipProps> = ({ isOpen, onClose }) => {
	const [fileList, setFileList] = useState<UploadFile[]>([]);
	const [previewVisible, setPreviewVisible] = useState(false)
	const [previewImage, setPreviewImage] = useState('')
	const [previewTitle, setPreviewTitle] = useState('')
	const [uploading, setUploading] = useState(false)
	const dispatch = useDispatch()
	const prefix = useSelector((state: ApplicationState) => state.prefix.info)

	useEffect(() => {
		dispatch(requestDepositTo())
	}, [dispatch])

	const getBase64 = (file: RcFile): Promise<string> =>
		new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => resolve(reader.result as string)
			reader.onerror = error => reject(error)
		})

	const handleCancel = () => setPreviewVisible(false)

	const handlePreview = async (file: UploadFile) => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj as RcFile)
		}

		setPreviewImage(file.url || (file.preview as string))
		setPreviewVisible(true)
		setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1))
	}

	const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => setFileList(newFileList as any)

	const beforeUploadPicture = (file: any) => {
		const isJpg = file.type === 'image/jpeg'
		const isPng = file.type === 'image/png'


		const isLt2M = file.size / 1024 / 1024 < 2

		if (!isJpg && !isPng) {
			toast.error('คุณสามารถอัปโหลดไฟล์ JPG เท่านั้น!')
			return Upload.LIST_IGNORE
		}

		if (!isLt2M) {
			toast.error('รูปภาพต้องมีขนาดเล็กกว่า 2MB!')
			return Upload.LIST_IGNORE
		}

		return false;
	}

	const handleUpload = async () => {
		const formData = new FormData()

		formData.append('file', fileList[0]?.originFileObj as RcFile)
		formData.append('bankNumber', bankNumber)
		setUploading(true)

		if (fileList.length > 0 && formData.get('bankNumber')) {
			try {
				const res = await api.post<void, APIResponse>('/deposit/scan-qrcode', formData)

				dispatch(requestUser())
				setFileList([])
				toast.success(res.message)
			} catch ({ message }: any) {
				setFileList([])
				toast.error(message as string)
			} finally {
				setUploading(false)
			}
		} else {
			setUploading(false)
			toast.error('กรุณาใส่ข้อมูลให้ครบถ้วน')
		}
	}

	const uploadButton = (
		<>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 -0.5 16 16" id="Bill-Check--Streamline-Solar" height="32" width="32"><desc>Bill Check Streamline Icon: https://streamlinehq.com</desc><g id="Line Duotone/Money/Bill Check"><path id="Vector" stroke="#fff" d="M10.471874999999999 1.25H4.5281375c-0.7242999999999999 0 -1.08644375 0 -1.37851875 0.10163125 -0.55385625 0.19271875 -0.9886937499999999 0.6403625000000001 -1.1759 1.21053125C1.875 2.8628437499999997 1.875 3.2356562500000003 1.875 3.9812874999999996V12.733875c0 0.5363749999999999 0.615625 0.8210000000000001 1.0050625 0.46462499999999995 0.22879375000000002 -0.209375 0.57358125 -0.209375 0.8023750000000001 0l0.30193749999999997 0.2763125c0.40099375 0.36693749999999997 1.00525625 0.36693749999999997 1.40625 0 0.40099375 -0.36693749999999997 1.00525 -0.36693749999999997 1.40625 0s1.00525 0.36693749999999997 1.40625 0 1.00525 -0.36693749999999997 1.40625 0 1.00525 0.36693749999999997 1.40625 0l0.30193749999999997 -0.2763125c0.22881249999999997 -0.209375 0.5735625 -0.209375 0.8023750000000001 0 0.3894375 0.356375 1.0050625 0.07175 1.0050625 -0.46462499999999995V3.9812874999999996c0 -0.74563125 0 -1.11844375 -0.09875 -1.419125 -0.1871875 -0.57016875 -0.622 -1.0178125 -1.175875 -1.21053125C11.558312500000001 1.25 11.1961875 1.25 10.471874999999999 1.25Z" stroke-width="1"></path><path id="Vector_2" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" d="m5.9375 6.5 0.8928750000000001 1L9.0625 5" stroke-width="1"></path><path id="Vector_3" stroke="#fff" stroke-linecap="round" d="M4.6875 9.6875h5.625" stroke-width="1"></path></g></svg>
			<div style={{ marginTop: 8 }}>คลิกหรือลากสลิปเพื่ออัปโหลด</div>
		</>
	)



	const depositToList = useSelector((state: ApplicationState) => state.deposit.depositToList)
	const depositToBanks = depositToList.filter((bank) => bank.bank !== 'truewallet' && bank.bank !== 'bbl')

	const replaceText = (text: string): string => {
		return text.split(' ').map((word, index) => {
			if (index > 0 && word.length > 2) {
				return word.substring(0, 1) + '*'.repeat(word.length - 1);
			}
			return word;
		}).join(' ');
	}

	const [bankNumber, setBankNumber] = useState('')

	useEffect(() => {
		// ตั้งค่า default เฉพาะตอนที่ยังไม่มีการเลือกธนาคาร
		if (depositToBanks.length > 0 && !bankNumber) {
			setBankNumber(depositToBanks[0].accountNumber)
		}
	}, [depositToBanks, bankNumber])

	const onChange = (e: RadioChangeEvent) => setBankNumber(e.target.value)

	return (
		<>
			<Modal
				className="ant-modal-deposit"
				open={isOpen}
				title="อัปโหลดสลิป"
				centered
				onCancel={() => !uploading && onClose()}
				footer={null}
			>
				<Text type="secondary" style={{ marginBottom: 8 }}>เลือกบัญชีที่เติมเงินเข้าไป</Text>
				<Radio.Group onChange={onChange} value={bankNumber} style={{ width: '100%', marginBottom: 24, marginTop: 8 }}>
					<Row gutter={[16, 16]}>
						{depositToBanks.map((bank, index) => (
							<Col xs={24} sm={24} md={24} key={index}>
								<Radio className="bank-radio" value={bank.accountNumber}>
									<Space direction='horizontal' size={1}>
										<div
											className="bank-card-logo-mini"
											style={{ boxShadow: `0 8px 12px -4px ${getBankColor(bank.bank)}` }}
										>
											<img
												src={Banks.filter(bankName => bankName.key === bank?.bank.toUpperCase())[0].image}
												alt={getBankName(bank.bank)}
											/>
										</div>
										<div className="bank-radio-info">
											<div><small>{getBankName(bank.bank)}</small></div>
											<div><b>{bank.accountNumber}</b></div>
											<div><small>{(prefix?.prefix === "AMBGAME" ||
												prefix?.prefix === "ALD88" ||
												prefix?.prefix === "LEXY88" ||
												prefix?.prefix === "1XHENG" ||
												prefix?.prefix === "WK89" ||
												prefix?.prefix === "LK789" ||
												prefix?.prefix === "K88" ||
												prefix?.prefix === "OD911" ||
												prefix?.prefix === "CB988" ||
												prefix?.prefix === "TH44" ||
												prefix?.prefix === "AT77" ||
												prefix?.prefix === "LK789") ? replaceText(bank.accountName) : bank.accountName}
											</small></div>
										</div>
									</Space>
								</Radio>
							</Col>
						))}
					</Row>
				</Radio.Group>
				<Upload
					className="ant-upload-drag-custom"
					listType="picture-card"
					fileList={fileList}
					onPreview={handlePreview}
					onChange={handleChange}
					beforeUpload={beforeUploadPicture}
				>
					{fileList.length >= 1 ? null : uploadButton}
				</Upload>
				<Button
					type="primary"
					htmlType="submit"
					loading={uploading}
					onClick={handleUpload}
					style={{ marginTop: 16 }}
					block
				>
					อัปโหลดสลิป
				</Button>
			</Modal>
			<Modal open={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
				<img alt={previewTitle} src={previewImage} style={{ width: '100%' }} />
			</Modal>
		</>
	)
}

export default UploadSlip
